'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import ActionButton from '@/components/Button/ActionButton';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { NotificationTargetTabs } from '../-components/NotificationTargetTabs';
import { NotificationPoliciesTable } from './-components/NotificationPoliciesTable';
export const Route = createFileRoute('/_staff/settings/notification-and-response/_layout/notification-policies/')({
  component: NotificationPolicies
});
function NotificationPolicies() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.notificationAndResponse.policies'
  });
  const navigate = useNavigate();
  return <NotificationTargetTabs actions={<ActionButton icon="PlusIcon" className="bg-primary-fill" onClick={() => navigate({
    to: '/settings/notification-and-response/notification-policies/new',
    search: {
      domain: 'business_package'
    }
  })}>
          {t('create')}
        </ActionButton>}>
      <NotificationPoliciesTable />
    </NotificationTargetTabs>;
}